export const ja = {
  heroData: {
    title: "お問い合わせ",
    subtitle: "横浜ヘリクルージングのご予約・ご相談は、こちらのフォームからお気軽にどうぞ。専任スタッフが2営業日以内にご返信いたします。",
    image: "https://readdy.ai/api/search-image?query=Elegant%20modern%20reception%20desk%20with%20warm%20ambient%20lighting%2C%20luxury%20concierge%20service%20atmosphere%2C%20dark%20navy%20and%20gold%20interior%20design%2C%20professional%20hospitality%20setting%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=contacthero01&orientation=landscape",
  },
  formFields: {
    name: { label: "お名前", placeholder: "例：山田 太郎", required: true },
    email: { label: "メールアドレス", placeholder: "例：example@email.com", required: true },
    phone: { label: "電話番号", placeholder: "例：090-1234-5678", required: false },
    inquiryType: {
      label: "お問い合わせ種別",
      options: [
        { value: "reservation", label: "予約相談" },
        { value: "pricing", label: "料金・プランについて" },
        { value: "gift", label: "ギフトチケットについて" },
        { value: "first-time", label: "初めての方への質問" },
        { value: "cancel", label: "キャンセル・変更" },
        { value: "other", label: "その他" },
      ],
      required: true,
    },
    preferredDate: { label: "希望日（任意）", placeholder: "例：2025年6月15日", required: false },
    message: { label: "お問い合わせ内容", placeholder: "ご質問やご希望を自由にご記入ください", required: true },
  },
  notesData: {
    label: "NOTE",
    title: "お問い合わせ前にご確認ください",
    items: [
      "メールアドレスは正しくご入力ください。返信が届かない場合は、迷惑メールフォルダもご確認ください。",
      "お電話でのご返信をご希望の場合は、電話番号を必ずご記入ください。",
      "繁忙期は返信にお時間をいただく場合があります。あらかじめご了承ください。",
      "キャンセル・変更のお問い合わせは、お早めにご連絡ください。",
    ],
  },
  finalCTA: {
    title: "まずは、お気軽に\nご相談ください",
    subtitle: "専任スタッフが、ご希望を丁寧にお伺いします",
    ctas: [
      { label: "料金・プランを見る", href: "/pricing", type: "primary" },
      { label: "初めての方はこちら", href: "/first-time", type: "secondary" },
    ],
  },
};

export const en = {
  heroData: {
    title: "Contact Us",
    subtitle: "For booking inquiries and questions about Yokohama Helicopter Cruise, please use the form below. Our dedicated staff will respond within 2 business days.",
    image: "https://readdy.ai/api/search-image?query=Elegant%20modern%20reception%20desk%20with%20warm%20ambient%20lighting%2C%20luxury%20concierge%20service%20atmosphere%2C%20dark%20navy%20and%20gold%20interior%20design%2C%20professional%20hospitality%20setting%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=contacthero01&orientation=landscape",
  },
  formFields: {
    name: { label: "Your Name", placeholder: "e.g. John Smith", required: true },
    email: { label: "Email Address", placeholder: "e.g. example@email.com", required: true },
    phone: { label: "Phone Number", placeholder: "e.g. 090-1234-5678", required: false },
    inquiryType: {
      label: "Inquiry Type",
      options: [
        { value: "reservation", label: "Booking Inquiry" },
        { value: "pricing", label: "Pricing & Plans" },
        { value: "gift", label: "Gift Tickets" },
        { value: "first-time", label: "First-Time Questions" },
        { value: "cancel", label: "Cancellations & Changes" },
        { value: "other", label: "Other" },
      ],
      required: true,
    },
    preferredDate: { label: "Preferred Date (optional)", placeholder: "e.g. June 15, 2025", required: false },
    message: { label: "Message", placeholder: "Please feel free to write your questions or requests here", required: true },
  },
  notesData: {
    label: "NOTE",
    title: "Before You Contact Us",
    items: [
      "Please double-check your email address. If you do not receive a reply, please check your spam folder.",
      "If you prefer a phone response, please include your phone number.",
      "During busy periods, replies may take longer than usual. We appreciate your patience.",
      "For cancellations or changes, please contact us as early as possible.",
    ],
  },
  finalCTA: {
    title: "Feel free to reach\nout anytime",
    subtitle: "Our dedicated staff will carefully listen to your needs",
    ctas: [
      { label: "View Pricing & Plans", href: "/pricing", type: "primary" },
      { label: "First-Time Visitors", href: "/first-time", type: "secondary" },
    ],
  },
};
